buyBonusPopup = {};

buyBonusPopup.infoText = undefined;

buyBonusPopup.init = function () {
  buyBonusPopup._callback = undefined;

  buyBonusPopup.buyBonusButton = resourceManager.get("buttonContainer:buttonBar:buyBonusButton");

  buyBonusPopup.background = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground");

  buyBonusPopup.closeButton = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:closeButton");

  buyBonusPopup.closeButton.onPressedCallback = buyBonusPopup.onClickedNo;

  buyBonusPopup.stakePreviousButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:stakePrevious"
  );

  buyBonusPopup.stakePreviousButton.onPressedCallback = buyBonusPopup.onStakePreviousPressed;

  buyBonusPopup.stakeNextButton = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:stakeNext");

  buyBonusPopup.stakeNextButton.onPressedCallback = buyBonusPopup.onStakeNextPressed;

  buyBonusPopup.baseStakeText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText"
  );

  buyBonusPopup.lowerFreeSpinsCostText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:totalWinPanel1:totalWinPanel1Text"
  );

  buyBonusPopup.middleFreeSpinsCostText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:totalWinPanel2:totalWinPanel2Text"
  );

  buyBonusPopup.higherFreeSpinsCostText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:totalWinPanel3:totalWinPanel3Text"
  );

  //buy buttons
  buyBonusPopup.lowerFreeSpinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton1"
  );
  buyBonusPopup.middleFreeSpinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton2"
  );
  buyBonusPopup.higherFreeSpinsButton = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:buyButton3"
  );

  buyBonusPopup.totalWinPanel1 = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:totalWinPanel1"
  );
  buyBonusPopup.totalWinPanel2 = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:totalWinPanel2"
  );
  buyBonusPopup.totalWinPanel3 = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:totalWinPanel3"
  );

  buyBonusPopup.baseStakePanel = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeTextPanel"
  );
  buyBonusPopup.baseStakeText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:baseStakeText"
  );
  buyBonusPopup.betPerSpinText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:betPerSpinText"
  );

  buyBonusPopup.chestPanelLow = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1");
  buyBonusPopup.chestPanelMed = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel2");
  buyBonusPopup.chestPanelHigh = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel3"
  );

  buyBonusPopup.chestPanel1AssetContainer = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1:chestPanel1AssetsContainer"
  );
  buyBonusPopup.chestPanel2AssetContainer = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel2:chestPanel2AssetsContainer"
  );
  buyBonusPopup.chestPanel3AssetContainer = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel3:chestPanel3AssetsContainer"
  );

  buyBonusPopup.lowerFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesLower;
  buyBonusPopup.middleFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesMed;
  buyBonusPopup.higherFreeSpinsButton.onPressedCallback = buyBonusPopup.onClickedYesHigh;

  buyBonusPopup.allElements = [
    buyBonusPopup.stakePreviousButton,
    buyBonusPopup.stakeNextButton,
    buyBonusPopup.baseStakeText,
    buyBonusPopup.lowerFreeSpinsCostText,
    buyBonusPopup.middleFreeSpinsCostText,
    buyBonusPopup.higherFreeSpinsCostText,
    buyBonusPopup.lowerFreeSpinsButton,
    buyBonusPopup.middleFreeSpinsButton,
    buyBonusPopup.higherFreeSpinsButton,
    buyBonusPopup.chestPanelLow,
    buyBonusPopup.chestPanelMed,
    buyBonusPopup.chestPanelHigh,
    buyBonusPopup.totalWinPanel1,
    buyBonusPopup.totalWinPanel2,
    buyBonusPopup.totalWinPanel3,
    buyBonusPopup.baseStakePanel,
    buyBonusPopup.baseStakeText,
    buyBonusPopup.betPerSpinText,
  ];

  buyBonusPopup.chestAnimations = {
    silver: resourceManager.createObject(
      "movie",
      "rightChestSilver",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        definition: "silverChest",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1.3,
        scaleY: 1.3,
        loop: false,
      }
    ),
    gold: resourceManager.createObject(
      "movie",
      "rightChestGold",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        definition: "goldChest",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1.3,
        scaleY: 1.3,
        loop: false,
      }
    ),
  };
  buyBonusPopup.burst = resourceManager.createObject(
    "sprite",
    "buyBonusBurst",
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
    {
      fileName: "Chests/Chest_Burst.png",
      x: 0,
      y: -194,
      scale: 2,
      anchor: 0.5,
    }
  );
  gsap.to(buyBonusPopup.burst, {
    duration: 3,
    rotation: Math.PI * 2,
    repeat: -1,
  });

  buyBonusPopup.chestAwardSprites = {
    6: resourceManager.createObject(
      "sprite",
      "6FreeSpins",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        fileName: "Chests/6FreeSpins.png",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      }
    ),
    8: resourceManager.createObject(
      "sprite",
      "8FreeSpins",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        fileName: "Chests/8FreeSpins.png",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      }
    ),
    10: resourceManager.createObject(
      "sprite",
      "10FreeSpins",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        fileName: "Chests/10FreeSpins.png",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      }
    ),
    12: resourceManager.createObject(
      "sprite",
      "12FreeSpins",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        fileName: "Chests/12FreeSpins.png",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      }
    ),
    16: resourceManager.createObject(
      "sprite",
      "16FreeSpins",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        fileName: "Chests/16FreeSpins.png",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      }
    ),
    20: resourceManager.createObject(
      "sprite",
      "20FreeSpins",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        fileName: "Chests/20FreeSpins.png",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      }
    ),
    24: resourceManager.createObject(
      "sprite",
      "24FreeSpins",
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer",
      {
        fileName: "Chests/24FreeSpins.png",
        anchor: { x: 0.5, y: 1 },
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      }
    ),
  };

  Object.values(buyBonusPopup.chestAwardSprites).forEach((sprite) => {
    sprite.visible = false;
  });
  buyBonusPopup.chestAnimations.silver.gotoAndStop(0);
  buyBonusPopup.chestAnimations.gold.gotoAndStop(0);
  buyBonusPopup.chestAnimations.silver.visible = false;
  buyBonusPopup.chestAnimations.gold.visible = false;

  buyBonusPopup.clickToContinue = resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer:continueContainer");
  gsap.to(buyBonusPopup.clickToContinue, {
    duration: 0.8,
    pixi: { scaleX: 0.92, scaleY: 0.92 },
    yoyo: true,
    repeat: -1,
    ease: "power1.inOut",
  });

  buyBonusPopup.clickToContinue.visible = false;

  buyBonusPopup.burst.visible = false;
};

buyBonusPopup.show = function (callback) {
  buyBonusPopup.open = true;
  gameController.justEnteredBuyABonus = true;
  buyBonusPopup.buyBonusButton.setIdleAnimVisible(false);

  buyBonusPopup.closeButton.visible = true;
  buyBonusPopup.closeButton.enableButton(true);

  // gameController.stopCyclingWins();

  messageBus.post("game:modal", {
    reason: "buy_bonus",
    data: "buy_bonus_show",
  });

  const highFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;
  const medFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.coinSizes;
  const lowFreeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;

  // combine all the stakes and remove duplicates - then sort
  // this might all go wrong with stake indexes as some stakes will only be in one mode and not the other
  buyBonusPopup.allStakesCombined = lowFreeSpinsStakes.concat(
    medFreeSpinStakes.filter(function (el) {
      medFreeSpinStakes.indexOf(el) === -1;
    }),
    highFreeSpinStakes.filter(function (el) {
      highFreeSpinStakes.indexOf(el) === -1;
    })
  );

  buyBonusPopup.allStakesCombined.sort(function (a, b, c) {
    return a - b - c;
  });

  // if the buy a bonus default stakes are different we choose the lowest of the two - game design
  const MedFreeSpinsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.defaultAmountPerLine;
  const fsDefault = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.defaultAmountPerLine;

  let defaultToUse = MedFreeSpinsDefault;

  if (MedFreeSpinsDefault !== fsDefault) {
    console.log("WARNING: Default buy a bonus stakes differ between modes");
    defaultToUse = Math.min(MedFreeSpinsDefault, fsDefault);
  }

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  const crtBaseStake = gameController.globalHelperGetBaseStake();
  const stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  const index = bonusBuyStakes.findIndex((stake) => stake * numLines === crtBaseStake);

  if (index !== -1) {
    buyBonusPopup.combinedStakeIndex = index;
  } else {
    buyBonusPopup.combinedStakeIndex = bonusBuyStakes.length - 1;
  }

  buyBonusPopup.updatePopup();

  resourceManager.getContainer("buyABonusContainer").visible = true;
  buyBonusPopup.container.visible = true;
  buyBonusPopup.callback = callback;
};

buyBonusPopup.updatePopup = function () {
  if (buyBonusPopup.stakeIndex === -1) {
    // Something went wrong here. No compatible stakes found
    buyBonusPopup.stakePreviousButton.enableButton(false);
    buyBonusPopup.stakeNextButton.enableButton(false);

    buyBonusPopup.higherFreeSpinsButton.enableButton(false);
    buyBonusPopup.middleFreeSpinsButton.enableButton(false);
    buyBonusPopup.lowerFreeSpinsButton.enableButton(false);
  } else {
    const bonusBuyStakes = buyBonusPopup.allStakesCombined;

    // update the stake buttons
    buyBonusPopup.stakePreviousButton.enableButton(buyBonusPopup.combinedStakeIndex > 0);
    buyBonusPopup.stakeNextButton.enableButton(buyBonusPopup.combinedStakeIndex < bonusBuyStakes.length - 1);

    // update the base stake box
    let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
    buyBonusPopup.baseStakeText.setText(gdk.formatCurrency(baseStake));

    // check stake is valid for each buy a bonus mode
    const highFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_HIGH.coinSizes;
    const medFreeSpinStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_MED.coinSizes;
    const lowFreeSpinsStakes = buyBonusPopup.gameConfig.data.slotConfig.gameModes.BONUS_BUY_LOW.coinSizes;

    // check stake is valid
    const stakeToFind = bonusBuyStakes[buyBonusPopup.combinedStakeIndex];

    let highFreespinsStakeExists = highFreeSpinStakes.includes(stakeToFind);
    let medFreespinsStakeExists = medFreeSpinStakes.includes(stakeToFind);
    let lowSpinsStakeExists = lowFreeSpinsStakes.includes(stakeToFind);

    //costs
    const costHighFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
    buyBonusPopup.higherFreeSpinsCostText.setText(gdk.formatCurrency(costHighFreespins));
    buyBonusPopup.higherFreeSpinsButton.enableButton(
      buyBonusPopup.balance >= costHighFreespins && highFreespinsStakeExists
    );

    const costMedFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMed;
    buyBonusPopup.middleFreeSpinsCostText.setText(gdk.formatCurrency(costMedFreespins));
    buyBonusPopup.middleFreeSpinsButton.enableButton(
      buyBonusPopup.balance >= costMedFreespins && medFreespinsStakeExists
    );

    const costlowFreespins = baseStake * buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
    buyBonusPopup.lowerFreeSpinsCostText.setText(gdk.formatCurrency(costlowFreespins));
    buyBonusPopup.lowerFreeSpinsButton.enableButton(buyBonusPopup.balance >= costlowFreespins && lowSpinsStakeExists);
  }
};

buyBonusPopup.create = function (json) {
  return new PIXI.Container();
};

buyBonusPopup.convertToTotalStake = function (coinSize) {
  const stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  return coinSize * numLines;
};

buyBonusPopup.onStakeNextPressed = function () {
  soundManager.play("buttonPressed");

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;
  buyBonusPopup.combinedStakeIndex = Math.min(buyBonusPopup.combinedStakeIndex + 1, bonusBuyStakes.length - 1);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.onStakePreviousPressed = function () {
  soundManager.play("buttonPressed");

  buyBonusPopup.combinedStakeIndex = Math.max(buyBonusPopup.combinedStakeIndex - 1, 0);
  buyBonusPopup.updatePopup();
};

buyBonusPopup.initialise = function (json, container) {
  buyBonusPopup.container = container;
  buyBonusPopup.container.visible = false;

  buyBonusPopup.fadedMask = new PIXI.Graphics();
  buyBonusPopup.fadedMask.beginFill(0, 0.8);
  buyBonusPopup.fadedMask.drawRect(-10000, -10000, 20000, 20000);
  buyBonusPopup.fadedMask.endFill();
  buyBonusPopup.container.addChild(buyBonusPopup.fadedMask);
  messageBus.subscribe("spinner:GameConfigEvent", buyBonusPopup.onGameConfig);
  messageBus.subscribe("common:BalanceEvent", buyBonusPopup.onBalanceEvent);
  messageBus.subscribe("game:modal", buyBonusPopup.onModal);

  buyBonusPopup.helpActive = false;
};

buyBonusPopup.onModal = function (data) {
  if (buyBonusPopup.container.visible) {
    if (data.reason && data.reason === "Options menu open") {
      buyBonusPopup.helpActive = true;

      buyBonusPopup.freeSpinsButton.enableButton(false);
      buyBonusPopup.closeButton.enableButton(false);

      // update the stake buttons
      buyBonusPopup.stakePreviousButton.enableButton(false);
      buyBonusPopup.stakeNextButton.enableButton(false);
    } else if (buyBonusPopup.helpActive) {
      buyBonusPopup.helpActive = false;

      buyBonusPopup.freeSpinsButton.enableButton(true);
      buyBonusPopup.closeButton.enableButton(true);

      buyBonusPopup.updatePopup();
    }

    if (buyBonusPopup.open) {
      if (data.reason === undefined) {
        messageBus.post("game:modal", {
          reason: "buy_bonus",
          data: "buy_bonus_show (onModal)",
        });
      }
    }
  }
};

buyBonusPopup.onGameConfig = function (event) {
  buyBonusPopup.gameConfig = event;
  buyBonusPopup.init();
};

buyBonusPopup.onBalanceEvent = function (event) {
  buyBonusPopup.balance = event.data.balance;
};

buyBonusPopup.onClosePopup = function (buyBonus) {
  buyBonusPopup.open = false;
  gameController.justEnteredBuyABonus = false;
  buyBonusPopup.buyBonusButton.setIdleAnimVisible(true);

  if (buyBonus) {
    musicManager.onFreeSpinsStart();
    soundManager.play("buyBonus");
  } else {
    soundManager.play("buyBonusClick");
  }

  let reels = resourceManager.get("slotContainer:reelContainer");
  reels.alpha = 1.0;

  buyBonusPopup.container.visible = false;
  if (buyBonusPopup._callback) {
    buyBonusPopup._callback();
    buyBonusPopup._callback = undefined;
    buyBonusPopup.reset();
  }
  buyBonusPopup.callback(buyBonus);
};

buyBonusPopup.onStartBonusSpin = function () {
  const sp = gdk.getServerParser();
  const isReplay = sp.isReplayMode !== undefined ? sp.isReplayMode() : false;
  if (isReplay) return;
  gameController.justEnteredBuyABonus = false;
  gameController.inBuyABonus = true;

  gameData.winningsMeter.set(0);
  gameController.totalWinnings = 0;

  // Remove modal
  messageBus.post("game:modal", { data: "buy_bonus_start" });

  let stakeController = resourceManager.getController("stakeController");
  const numLines = stakeController.CurrentWinLineCount;

  const bonusBuyStakes = buyBonusPopup.allStakesCombined;

  // we should be ok to use the combined stake index as the button will be disabled if not an allowable stake
  let baseStake = buyBonusPopup.convertToTotalStake(bonusBuyStakes[buyBonusPopup.combinedStakeIndex]);
  let stakes = stakeController.Stakes;
  let returnStake = stakes.find((stake) => stake === baseStake);

  if (!returnStake) {
    returnStake = stakes[0];
  }

  stakeController.requestChangeStake(returnStake);

  let bonusType;
  let buyCost;

  gameController.buyBonusLow = false;
  gameController.buyBonusMed = false;
  gameController.buyBonusHigh = false;

  if (buyBonusPopup.buyBonusHigh) {
    bonusType = "BONUS_BUY_HIGH";
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsHigh;
    gameController.buyBonusHigh = true;
  } else if (buyBonusPopup.buyBonusMed) {
    bonusType = "BONUS_BUY_MED";
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsMed;
    gameController.buyBonusMed = true;
  } else {
    bonusType = "BONUS_BUY_LOW";
    buyCost = buyBonusPopup.gameConfig.data.buyBonusCostFreeSpinsLow;
    gameController.buyBonusLow = true;
  }

  stakeController.requestChangeStake(baseStake, bonusType);

  const bpl = baseStake / numLines;

  gameController.boughtBonus = true;

  resourceManager.get("potMetersContainer").updateMeterValues();
  gameController.stopCyclingWins();
  
  gdk.startGame(
    {
      stake: baseStake * buyCost,
      numWinlines: numLines,
      bpl: bpl,
      metaData: {
        encore: false,
        buyABonus: true,
        buyBonusLowActive: buyBonusPopup.buyBonusLow,
        buyBonusMedActive: buyBonusPopup.buyBonusMed,
        buyBonusHighActive: buyBonusPopup.buyBonusHigh,
      },
    },
    function () {
      gdk.getNextGameOutcome(function () {});
    }
  );
};

buyBonusPopup.onClickedYes = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedFreeSpins = function () {
  buyBonusPopup.onClosePopup(true);
};

buyBonusPopup.onClickedYesLower = async () => {
  soundManager.play("buyBonusClick");

  buyBonusPopup.buyBonusHigh = false;
  buyBonusPopup.buyBonusMed = false;
  buyBonusPopup.buyBonusLow = true;
  buyBonusPopup.closeButton.visible = false;
  buyBonusPopup.closeButton.enableButton(false);
  this._chosenChest = buyBonusPopup.chestPanelLow;
  this._chosenChestOrigin = {
    x: buyBonusPopup.chestPanelLow.x,
    y: buyBonusPopup.chestPanelLow.y,
  };

  this._chestSprite = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1:chestPanel1AssetsContainer:chestPanel1ChestAsset"
  );
  this._chestPanelText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1:chestPanel1AssetsContainer:chestPanel1Text"
  );
  this._chestPanelText.visible = false;
  buyBonusPopup.hideElements(this._chosenChest);

  await Promise.all([
    gsap
      .timeline()
      .to(this._chosenChest, {
        duration: 1,
        ease: "linear",
        x: 5,
        y: -19,
      })
      .to(
        this._chosenChest.scale,
        {
          duration: 1,
          ease: "linear",
          x: 2,
          y: 2,
          onComplete: async () => {
            buyBonusPopup.onStartBonusSpin();
          },
        },
        "<"
      ),
    gsap.to(buyBonusPopup.chestPanel1AssetContainer, {
      duration: 1,
      ease: "linear",
      x: 0,
      y: 10,
    }),
  ]);
};

buyBonusPopup.onClickedYesMed = async () => {
  soundManager.play("buyBonusClick");

  buyBonusPopup.buyBonusHigh = false;
  buyBonusPopup.buyBonusMed = true;
  buyBonusPopup.buyBonusLow = false;
  buyBonusPopup.closeButton.visible = false;
  buyBonusPopup.closeButton.enableButton(false);
  this._chosenChest = buyBonusPopup.chestPanelMed;
  this._chosenChestOrigin = {
    x: buyBonusPopup.chestPanelMed.x,
    y: buyBonusPopup.chestPanelMed.y,
  };
  this._chestSprite = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel2:chestPanel2AssetsContainer:chestPanel2ChestAsset"
  );
  this._chestPanelText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel2:chestPanel2AssetsContainer:chestPanel2Text"
  );
  this._chestPanelText.visible = false;
  buyBonusPopup.hideElements(this._chosenChest);

  await Promise.all([
    gsap
      .timeline()
      .to(this._chosenChest, {
        duration: 1,
        ease: "linear",
        x: 5,
        y: -19,
      })
      .to(
        this._chosenChest.scale,
        {
          duration: 1,
          ease: "linear",
          x: 2,
          y: 2,
          onComplete: async () => {
            buyBonusPopup.onStartBonusSpin();
          },
        },
        "<"
      ),
    gsap.to(buyBonusPopup.chestPanel2AssetContainer, {
      duration: 1,
      ease: "linear",
      x: 0,
      y: 10,
    }),
  ]);
};

buyBonusPopup.onClickedYesHigh = async () => {
  soundManager.play("buyBonusClick");

  buyBonusPopup.buyBonusHigh = true;
  buyBonusPopup.buyBonusMed = false;
  buyBonusPopup.buyBonusLow = false;
  buyBonusPopup.closeButton.visible = false;
  buyBonusPopup.closeButton.enableButton(false);
  this._chosenChest = buyBonusPopup.chestPanelHigh;
  this._chosenChestOrigin = {
    x: buyBonusPopup.chestPanelHigh.x,
    y: buyBonusPopup.chestPanelHigh.y,
  };
  this._chestSprite = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel3:chestPanel3AssetsContainer:chestPanel3ChestAsset"
  );
  this._chestPanelText = resourceManager.get(
    "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel3:chestPanel3AssetsContainer:chestPanel3Text"
  );
  this._chestPanelText.visible = false;
  buyBonusPopup.hideElements(this._chosenChest);

  await Promise.all([
    gsap
      .timeline()
      .to(this._chosenChest, {
        duration: 1,
        ease: "linear",
        x: 5,
        y: -19,
      })
      .to(
        this._chosenChest.scale,
        {
          duration: 1,
          ease: "linear",
          x: 2,
          y: 2,
          onComplete: async () => {
            buyBonusPopup.onStartBonusSpin();
          },
        },
        "<"
      ),
    gsap.to(buyBonusPopup.chestPanel3AssetContainer, {
      duration: 1,
      ease: "linear",
      x: 0,
      y: 10,
    }),
  ]);
};

buyBonusPopup.fadeMysteryChestOut = async (level) => {
  return new Promise((resolve) => {
    const chest = level === 0 ? buyBonusPopup.chestAnimations.silver : buyBonusPopup.chestAnimations.gold;
    gsap.to(this._chestSprite, {
      duration: 0.5,
      alpha: 0,
    });
    chest.visible = true;
    gsap.fromTo(
      chest,
      {
        duration: 0.5,
        alpha: 0,
      },
      {
        alpha: 1,
        onComplete: () => {
          resolve();
        },
      }
    );
  });
};

buyBonusPopup.openChest = async (level, numFS, callback, openChestCb) => {
  const sp = gdk.getServerParser();
  const isReplay = sp.isReplayMode !== undefined ? sp.isReplayMode() : false;
  if (isReplay) {
    buyBonusPopup.show(() => {});
    if (gameController.buyBonusType === "BONUS_BUY_LOW") {
      await buyBonusPopup.onClickedYesLower();
    } else if (gameController.buyBonusType === "BONUS_BUY_MED") {
      await buyBonusPopup.onClickedYesMed();
    } else {
      await buyBonusPopup.onClickedYesHigh();
    }
  }

  buyBonusPopup._callback = callback;
  if (!this._chestSprite) {
    this._chestSprite = resourceManager.get(
      "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1:chestPanel1AssetsContainer:chestPanel1ChestAsset"
    );
  }

  switch (level) {
    case 0:
      if (!this._chestPanelText) {
        this._chestPanelText = resourceManager.get(
          "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel1:chestPanel1AssetsContainer:chestPanel1Text"
        );
      }
      if (buyBonusPopup.buyBonusMed) {
        await buyBonusPopup.fadeMysteryChestOut(level);
      }
      buyBonusPopup.showBonusChest(true, 0);
      await buyBonusPopup.wiggleChest(
        buyBonusPopup.buyBonusMed ? buyBonusPopup.chestAnimations.silver : this._chestSprite
      );
      buyBonusPopup.clickToContinue.visible = true;
      resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer:allDevilsActive").visible = false;
      this._chestSprite.visible = false;
      buyBonusPopup.chestAnimations.silver.visible = true;
      soundManager.play("chestOpen");
      buyBonusPopup.chestAnimations.silver.play();
      buyBonusPopup.chestAnimations.silver.onComplete = () => {
        if (openChestCb) {
          openChestCb();
        }

        buyBonusPopup.burst.visible = true;
        buyBonusPopup.chestAwardSprites[numFS].visible = true;
        musicManager.onFreeSpinsIntro();
        gsap
          .timeline()
          .fromTo(buyBonusPopup.burst.scale, { x: 0.25, y: 0.25 }, { duration: 0.1, x: 2, y: 2 })
          .fromTo(buyBonusPopup.burst, { alpha: 0 }, { alpha: 1, duration: 0.1 }, "<");
        // .to(buyBonusPopup.burst, {
        //   duration: 3,
        //   rotation: Math.PI * 2,
        //   repeat: -1,
        // });
        buyBonusPopup.setActive();
      };
      break;
    case 1:
      if (!this._chestPanelText) {
        this._chestPanelText = resourceManager.get(
          "buyABonusContainer:buyBonusPopup:buyABonusBackground:chestPanel3:chestPanel3AssetsContainer:chestPanel3Text"
        );
      }
      if (buyBonusPopup.buyBonusMed) {
        await buyBonusPopup.fadeMysteryChestOut(level);
      }
      buyBonusPopup.showBonusChest(true, 1);
      await buyBonusPopup.wiggleChest(
        buyBonusPopup.buyBonusMed ? buyBonusPopup.chestAnimations.gold : this._chestSprite
      );
      buyBonusPopup.clickToContinue.visible = true;
      resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer:allDevilsActive").visible = false;
      this._chestSprite.visible = false;
      this._chestPanelText.visible = false;
      buyBonusPopup.chestAnimations.gold.visible = true;
      soundManager.play("chestOpen");
      buyBonusPopup.chestAnimations.gold.play();
      buyBonusPopup.chestAnimations.gold.onComplete = () => {
        if (openChestCb) {
          openChestCb();
        }

        buyBonusPopup.burst.visible = true;
        buyBonusPopup.chestAwardSprites[numFS].visible = true;
        musicManager.onFreeSpinsIntro();
        gsap
          .timeline()
          .fromTo(buyBonusPopup.burst.scale, { x: 0.25, y: 0.25 }, { duration: 0.1, x: 2, y: 2 })
          .fromTo(buyBonusPopup.burst, { alpha: 0 }, { alpha: 1, duration: 0.1 }, "<");
        // .to(buyBonusPopup.burst, {
        //   duration: 3,
        //   rotation: Math.PI * 2,
        //   repeat: -1,
        // });
        buyBonusPopup.setActive();
      };
      break;
  }
  musicManager.playDevilLaughSound();
};

buyBonusPopup.setActive = () => {
  buyBonusPopup.background.interactive = true;
  buyBonusPopup.background.mousedown = buyBonusPopup.background.touchstart = buyBonusPopup.onClosePopup.bind(
    this,
    true
  );
};

buyBonusPopup.showBonusChest = (show, level) => {
  const chests = resourceManager.get("chestsContainer");
  chests._showBonusChest(show, level);
};

buyBonusPopup.hideElements = (chest) => {
  const filteredElements = buyBonusPopup.allElements.filter((element) => element !== chest);
  console.log(filteredElements);
  filteredElements.forEach((element) => {
    element.visible = false;
  });
};

buyBonusPopup.wiggleChest = async (chest) => {
  soundManager.play("chestShake");

  const tweenConfig = {
    firstRotate: { rotation: 0.15, duration: 0.1, ease: "power1.inOut" },
    secondRotate: { rotation: -0.15, duration: 0.2, ease: "power1.inOut" },
    centre: { rotation: 0, duration: 0.1, ease: "power1.inOut" },
  };

  return gsap
    .timeline()
    .to(chest, tweenConfig.firstRotate)
    .to(chest, tweenConfig.secondRotate)
    .to(chest, tweenConfig.firstRotate)
    .to(chest, tweenConfig.secondRotate)
    .to(chest, tweenConfig.centre);
};

buyBonusPopup.onClickedNo = function () {
  buyBonusPopup.open = false;
  buyBonusPopup.buyBonusButton.setIdleAnimVisible(true);

  messageBus.post("game:modal", { data: "buy_bonus_cancel" });

  buyBonusPopup.onClosePopup(false);
};

buyBonusPopup.reset = () => {
  buyBonusPopup.allElements.forEach((element) => {
    element.visible = true;
  });
  Object.values(buyBonusPopup.chestAwardSprites).forEach((sprite) => {
    sprite.visible = false;
  });
  this._chestSprite.visible = true;
  this._chestSprite.alpha = buyBonusPopup.buyBonusMed ? 0.5 : 1;
  this._chestPanelText.visible = true;
  this._chosenChest.x = this._chosenChestOrigin.x;
  this._chosenChest.y = this._chosenChestOrigin.y;
  this._chosenChest.scale = { x: 1, y: 1 };
  buyBonusPopup.chestPanel1AssetContainer.y = 0;
  buyBonusPopup.chestPanel2AssetContainer.y = 0;
  buyBonusPopup.chestPanel3AssetContainer.y = 0;
  buyBonusPopup.burst.visible = false;
  buyBonusPopup.clickToContinue.visible = false;
  resourceManager.get("buyABonusContainer:buyBonusPopup:buyABonusBackground:chestAnimationContainer:allDevilsActive").visible = true;
  
  buyBonusPopup.chestAnimations.silver.gotoAndStop(0);
  buyBonusPopup.chestAnimations.gold.gotoAndStop(0);
  buyBonusPopup.chestAnimations.silver.visible = false;
  buyBonusPopup.chestAnimations.gold.visible = false;
  buyBonusPopup.background.interactive = false;
  buyBonusPopup.background.mousedown = buyBonusPopup.background.touchstart = undefined;
};

buyBonusPopup.onInfo = function () {
  soundManager.play("buttonPressed");
  gameData.helpPageScroll.open();
};

buyBonusPopup.getFilesRequired = function (json) {
  return [];
};

resourceManager.registerObjectType(
  "buyBonusPopup",
  buyBonusPopup.create,
  buyBonusPopup.initialise,
  buyBonusPopup.getFilesRequired
);
